export default {"src":"/_next/static/media/tooltip-icon.b0457c04.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};